var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPPeykMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.97 20.96-1.94-.65a1.518 1.518 0 0 0-1.11.04 6.951 6.951 0 0 1-7.845-1.381.3.3 0 0 1 .229-.5A8.524 8.524 0 0 0 18.47 9.3c-.048-.286.3-.454.58-.13a7 7 0 0 1 1.3 7.75c-.422.74.44 2.322.61 3.05a.785.785 0 0 1-.99.99zM10 17a6.936 6.936 0 0 1-2.924-.646 1.5 1.5 0 0 0-1.1-.046l-1.945.653a.783.783 0 0 1-.987-.988l.653-1.944a1.5 1.5 0 0 0-.047-1.1A7 7 0 1 1 10 17zm2-7a1 1 0 1 0 1-1h-.009A1 1 0 0 0 12 10zm-4 0a1 1 0 0 0-1-1h-.007A1 1 0 1 0 8 10zm2.018 1a1 1 0 0 0 0-2h-.01a1 1 0 0 0 .01 2z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPPeykMessage);
export default __webpack_public_path__ + "static/media/PPeykMessage.99bafc53273cbaba4cdae0ee202e6362.svg";
export { ForwardRef as ReactComponent };